import store from '@/store';
import client from './apiCommonConnector';

export default {
  async addContactType(typeName) {
    try {
      const type = { display_name: typeName, name: typeName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ /g, '_') };
      const newTypeResponse = await client().post('/ambassador/contacts/types', type);
      const newType = newTypeResponse.data;
      store.commit('contacts/setTypes', [...store.state.contacts.types, newType]);
      return newType;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de création du type',
        detail: "Une erreur s'est produite lors de la création du nouveau type de contact, veuillez réessayer.",
      });
      return false;
    }
  },

  async addClientType(typeName, categoryId) {
    try {
      const type = {
        display_name: typeName,
        name: typeName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ /g, '_'),
        category: { id: categoryId },
      };
      const newTypeResponse = await client().post('/ambassador/clients/types', type);
      const newType = newTypeResponse.data;
      store.commit('clients/setTypes', [...store.state.clients.types, newType]);
      return newType;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de création du type',
        detail: "Une erreur s'est produite lors de la création du nouveau type de compte, veuillez réessayer.",
      });
      return false;
    }
  },

  async getContactCategories() {
    try {
      // const categoriesResponse = await client().get('/ambassador/contacts/types/categories');
      const categoriesResponse = { data: [] };
      return categoriesResponse.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des catégories de types de contact, veuillez réessayer.",
      });
      return [];
    }
  },

  async getClientCategories() {
    try {
      const categoriesResponse = await client().get('/ambassador/clients/types/categories');
      return categoriesResponse.data.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des catégories de types de compte, veuillez réessayer.",
      });
      return [];
    }
  },
};
